import React from 'react'
import { useMap } from '../hooks'

const Map = ({ children, id }) => {
  useMap(id)

  const kids = React.Children.map(children, (child) => {
    return React.cloneElement(child, { mapId: id })
  })

  return (
    <div id={`mym-map-${id}`} className="mym-map">
      {kids}
    </div>
  )
}

export default Map
